/**
 * Toasts de éxito y error.
 */
// --- Toasts: éxito ---
export const toastSuccess = {
  configUpdated: (providerName: string) => `Configuración de ${providerName} actualizada exitosamente`,
  responseSaved: 'Respuesta guardada correctamente',
  accountDeactivated: 'Tu cuenta ha sido desactivada',
  reminderDeleted: 'Recordatorio eliminado exitosamente',
  reminderCompleted: 'Recordatorio marcado como completado',
  reminderUpdated: 'Recordatorio actualizado',
  reminderCreated: 'Recordatorio creado exitosamente',
  paymentApproved: 'Pago aprobado exitosamente',
  paymentRejected: 'Pago rechazado',
  draftLoaded: 'Borrador cargado',
  draftLoadedWithAI: 'Borrador cargado. Se generó automáticamente una sugerencia.',
  aiProcessed: 'Información guardada correctamente',
  schedulesReloaded: 'Horarios recargados',
  scheduleCreated: 'Horario creado correctamente',
  scheduleUpdated: 'Horario actualizado correctamente',
  scheduleDeleted: 'Horario eliminado correctamente',
  appointmentCreated: 'Cita creada exitosamente',
  appointmentUpdated: 'Cita actualizada exitosamente',
  appointmentCancelled: 'Cita cancelada exitosamente',
  profileImageUploaded: 'Imagen de perfil subida exitosamente',
  profileImageFromDraft: 'Imagen de perfil subida exitosamente desde el borrador',
  controlImagesUploaded: (n: number) => `${n} imagen(es) de controles subida(s) exitosamente`,
  vaccinationsProcessed: 'Vacunaciones procesadas correctamente',
  controlsCreated: (n: number) => `${n} control(es) médico(s) creado(s) correctamente`,
  petCreated: 'Mascota creada exitosamente',
  profileImageUpdated: 'Imagen de perfil actualizada exitosamente',
  imagesDeleted: (n: number) => `${n} imagen(es) eliminada(s)`,
  petUpdated: 'Mascota actualizada exitosamente',
  controlCreated: 'Control médico creado exitosamente',
  vaccineRegistered: 'Vacuna registrada exitosamente',
  prescriptionUploaded: 'Receta subida exitosamente. Se ha descontado 1 uso del límite de archivos.',
  veterinarianRegistered: '¡Registro exitoso! Ahora estás autenticado en el sistema.',
  imageReady: 'Imagen recortada y lista para subir',
  notificationCreated: 'Notificación creada exitosamente',
  notificationSent: 'Notificación enviada exitosamente',
  notificationDeleted: 'Notificación eliminada exitosamente',
  userAssignedToClinic: 'Usuario asignado a clínica exitosamente',
  roleUpdated: 'Rol actualizado exitosamente',
  roleDeleted: 'Rol eliminado exitosamente',
  userCreated: 'Usuario creado exitosamente',
  userUpdated: 'Usuario actualizado exitosamente',
  userStatusUpdated: 'Estado del usuario actualizado exitosamente',
  passwordReset: 'Contraseña restablecida exitosamente', // pragma: allowlist secret
  userBlacklisted: 'Usuario agregado a la lista negra',
  userUnblacklisted: 'Usuario removido de la lista negra',
  accountCreated: 'Cuenta creada exitosamente. Revisa tu correo para el código de verificación.',
  itemCreated: 'Item creado correctamente',
  movementRegistered: 'Movimiento registrado',
  draftDeleted: 'Borrador eliminado correctamente',
  petDeleted: 'Mascota eliminada exitosamente',
  subscriptionDeactivated: 'Suscripción desactivada exitosamente',
  vaccineAdded: 'Vacuna agregada con fecha',
  draftSaved: 'Borrador guardado correctamente',
  interviewCompleted: 'Entrevista realizada correctamente',
  sessionClosed: 'Sesión cerrada exitosamente',
  userRegistered: 'Usuario registrado exitosamente',
  groomingDeleted: 'Control de peluquería eliminado correctamente',
  controlDeleted: 'Control médico eliminado correctamente',
  vaccinationDeleted: 'Vacunación eliminada correctamente',
  medicalRecordDeleted: 'Registro clínico eliminado correctamente',
  fileUploaded: 'Archivo subido correctamente',
  fileDeleted: 'Archivo eliminado',
  planCreated: 'Plan creado exitosamente',
  planDeactivated: 'Plan desactivado exitosamente',
  planChangedFree: (name: string) => `Plan cambiado a ${name} sin costo adicional.`,
  pdfDownloaded: 'PDF del resumen clínico descargado exitosamente',
  clipboardCopied: 'Copiado al portapapeles',
} as const;

// --- Toasts: error (mensajes fijos; para errores de API usar errors.* o detail del backend) ---
export const toastError = {
  imageTooLarge: 'Imagen demasiado grande (máx. 10MB)',
  someControlImagesFailed: 'Mascota creada, pero algunas imágenes de controles no se pudieron subir',
  someImagesDeleteFailed: 'Mascota actualizada, pero algunas imágenes no se pudieron eliminar',
  someControlImagesUpdateFailed: 'Mascota actualizada, pero algunas imágenes de controles no se pudieron subir',
  trialActiveNoSubscribe: 'No puedes suscribirte a ningún plan mientras tu período de prueba esté activo. Espera a que termine tu período de prueba para suscribirte.',
  planChangePreview: 'No se pudo verificar el cambio de plan',
  deleteDraftPrefix: 'Error al eliminar borrador:',
  deletePetReasonRequired: '⚠️ El motivo de eliminación es obligatorio. Por favor, ingresa un motivo antes de eliminar.',
  deletePetReasonMinLength: '⚠️ El motivo debe tener al menos 3 caracteres.',
  sessionExpired: 'Tu sesión ha expirado. Por favor inicia sesión nuevamente.',
  sessionInactive: 'Tu sesión se cerró por inactividad.',
  clipboardCopyFailed: 'No se pudo copiar',
} as const;
